package org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_selection.selection

import kotlinx.serialization.Serializable

@Serializable
data class ProductSetRequest(
    val sets: List<ProductSetData>
)

@Serializable
data class ProductSetData(
    val category: String?,
    val minQuantity: Int?,
    val maxQuantity: Int?,
    val priceLevel: Int?,
    val isCollectPoints: Boolean?,
    val weekDays: Int?,
    val course: String?,
    val fixProducts: List<FixProductData>?
)

@Serializable
data class FixProductData(
    val code: String?,
    val amount: Int?,
    val price: Double?
)